export default "__VITE_ASSET__BDyVQ7w9__";